import { Controller } from '@hotwired/stimulus';

export class FaqController extends Controller {
  static targets = [
    'category',
    'item',
    'query',
    'noResults',
  ];

  connect() {
    this.applyParams();
    this.filter();
  }

  applyParams() {
    const params = new URLSearchParams(window.location.search);

    const category = params.get('category');
    if (category) {
      this.categoryTarget.value = category;
    }

    const item = params.get('item');
    if (item) {
      const target = this.itemTargets.find(target => target.dataset.id === item);
      if (target) {
        target.dataset.forceVisible = 'true';
        target.querySelector('button').click();
        target.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }

  filter() {
    const category = this.categoryTarget.value;
    const query = this.queryTarget.value;
    const hasFilters = category !== '' || query !== '';
    let visibleCount = 0;

    this.itemTargets.forEach(item => {
      const isPopular = item.dataset.popular === 'true';
      const categories = item.dataset.categories.split('|');
      const content = item.innerText.toLowerCase();

      const matchesCategory = category === '' || categories.includes(category);
      const matchesQuery = content.includes(query);

      const isVisible = item.dataset.forceVisible === 'true' || (hasFilters ? (matchesCategory && matchesQuery) : isPopular);
      if (isVisible) visibleCount++;

      item.hidden = !isVisible;
    });

    this.noResultsTarget.hidden = visibleCount > 0;
  }
}
